import {orderBy} from 'lodash'
import {checkKeyTransformData, getRootKeyTransformData} from "@helpers/transform/transform";
import {ColumnId} from "@ui/tableCustom/types/columns";

export const buildExportData = <T>({
                                       data,
                                       order,
                                       direction,
                                       keys,
                                       t,
                                   }: {
    data: T[],
    order?: keyof T | false,
    direction?: string,
    keys: ColumnId<T>[],
    t: (key: string) => string,
}): T[] => {

    const arrWidthTransformName: T[] = data?.map((item) => {
        let newItem: Record<string, unknown> = {...item as object}
        const currentArr = Object.entries(item);
        currentArr.forEach((it) => {
            const [key, value] = it;
            const hasTransformKey = checkKeyTransformData(key)
            if (hasTransformKey) {
                const rootKey = getRootKeyTransformData(key)
                newItem[rootKey as keyof unknown] = value
            }

        })
        return newItem;
    }) as T[]
    let exportData = arrWidthTransformName?.map((obj) => keys.reduce((acc, key) => {
        if (typeof obj[key as keyof T] === 'boolean') {
            // @ts-ignore
            acc[key] = obj[key as keyof T] ? t('base.yes') : t('base.no');
        } else {
            // @ts-ignore
            acc[key] = obj[key as keyof T]

        }
        return acc;
    }, {}));


    if (order && direction) {
        exportData = orderBy(exportData, [order], [direction.toLowerCase() as 'asc']);
    }

    return exportData as T[];
}